// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { node } from 'prop-types';

const OrderTypeBadgeWrapper = styled.div`
  border: 1px solid #3A3A3A;
  border-radius: 6px;
  font-size: 0.875rem;
  padding: 0 19px;
  margin-top: 5px;
  line-height: 22px;
  font-weight: 400;
  text-transform: capitalize;
`;

const NWOrderTypeBadge = ({ children }) => (
  <OrderTypeBadgeWrapper>
    { children }
  </OrderTypeBadgeWrapper>
);

NWOrderTypeBadge.propTypes = {
  children: node
};

export { NWOrderTypeBadge };
